import { createContext, Dispatch, SetStateAction, useContext } from 'react'
import { noop } from 'lodash'
import type { PreviousPage } from 'ui/components/ScreenLayout'

export interface SidebarContextProps {
  minimised?: boolean
  setMinimised: Dispatch<SetStateAction<boolean>>
  previousPages?: PreviousPage[]
  title: string | null
  setTitle: Dispatch<SetStateAction<string | null>>
  setPreviousPages: Dispatch<SetStateAction<any[]>>
  lightTheme?: boolean
}

export const SidebarContext = createContext<SidebarContextProps>({
  setMinimised: noop,
  setPreviousPages: noop,
  setTitle: noop,
  title: null,
})

export const useSidebar = () => useContext(SidebarContext)
